import Description from "./description";
import Header from "./header";
import Title from "./title";
import Body from "./body";
import Root from "./root";
import Footer from "../offcanvas-form/footer";

const Modal = {
    Root,
    Header,
    Body,
    Title,
    Description,
    Footer,
};
export default Modal;
